(() => {
  const nav = document.querySelector('[data-avona-nav]');
  if (!nav) return;
  const header = document.querySelector('.section-header');
  const sentinel = nav.previousElementSibling;
  const links = [...nav.querySelectorAll('a[href^="#"]')];
  // Each model row is a scroll target; the Callis 32 deep-dive belongs to the Callis 32 link.
  const targets = [];
  links.forEach((link) => {
    const el = document.querySelector(link.getAttribute('href'));
    if (el) targets.push({ el, link });
    if (link.getAttribute('href') === '#avona-callis-32') {
      const dive = document.getElementById('callis-32-deep-dive');
      if (dive) targets.push({ el: dive, link });
    }
  });

  const headerOffset = () => {
    if (!header || header.classList.contains('shopify-section-header-hidden')) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  };

  let ticking = false;
  const update = () => {
    ticking = false;
    nav.style.setProperty('--avona-sticky-top', `${headerOffset()}px`);
    if (sentinel) nav.classList.toggle('is-stuck', sentinel.getBoundingClientRect().top < 0);
    const line = nav.getBoundingClientRect().bottom + 40;
    let active = null;
    targets.forEach(({ el, link }) => { if (el.getBoundingClientRect().top <= line) active = link; });
    const last = targets[targets.length - 1];
    if (last && last.el.getBoundingClientRect().bottom < line) active = null; // past the models
    links.forEach((link) => {
      const on = link === active;
      if (on && link.getAttribute('aria-current') !== 'true' && nav.scrollWidth > nav.clientWidth) {
        nav.scrollTo({ left: link.offsetLeft - 24, behavior: 'smooth' });
      }
      link.setAttribute('aria-current', on ? 'true' : 'false');
    });
  };
  const request = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  // The theme header animates in and out after scrolling stops; follow it.
  if (header) new MutationObserver(() => { request(); setTimeout(request, 160); setTimeout(request, 320); }).observe(header, { attributes: true, attributeFilter: ['class'] });

  links.forEach((link) => link.addEventListener('click', (event) => {
    const el = document.querySelector(link.getAttribute('href'));
    if (!el) return;
    event.preventDefault();
    const y = el.getBoundingClientRect().top + window.scrollY - nav.offsetHeight - 12;
    window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    history.replaceState(null, '', link.getAttribute('href'));
  }));
  update();
})();
